/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const ERROR_MESSAGE_MAP = {
  MEDIA_ERR_ABORTED: "The video download was cancelled.",
  MEDIA_ERR_NETWORK:
    "The video connection was lost, please confirm you are connected to the internet.",
  MEDIA_ERR_SRC_NOT_SUPPORTED:
    "This video is either unavailable or not supported in this browser.",
  MEDIA_ERR_DECODE:
    "The video is bad or in a format that cannot be played on your browser.",
  MEDIA_ERR_ENCRYPTED:
    "The video you are trying to watch is encrypted and we do not know how to decrypt it.",
  MEDIA_ERR_UNKNOWN:
    "An unanticipated problem was encountered, check back soon and try again.",
  MEDIA_ERR_CUSTOM:
    "An problem was encountered, check back soon and try again.",
};

export type PlayerError = keyof typeof ERROR_MESSAGE_MAP;

export const PLAYER_STATUS_CODE_TO_ERROR_MESSAGE_MAP: {
  [code in string]?: PlayerError;
} = {
  "1": "MEDIA_ERR_ABORTED",
  "2": "MEDIA_ERR_NETWORK",
  "3": "MEDIA_ERR_DECODE",
  "4": "MEDIA_ERR_SRC_NOT_SUPPORTED",
  "5": "MEDIA_ERR_ENCRYPTED",
  unknown: "MEDIA_ERR_UNKNOWN",
};

// TODO: This is a simplified mapping of Shaka errors, based on what we have for videoJS
// Shaka has 10 cateogires, we may want to adjust translation keys for this -> https://shaka-player-demo.appspot.com/docs/api/shaka.util.Error.html#.Category
export const PLAYER_CATEGORY_CODE_TO_ERROR_MESSAGE_MAP: {
  [code in string]?: PlayerError;
} = {
  "1": "MEDIA_ERR_NETWORK",
  "2": "MEDIA_ERR_DECODE",
  "3": "MEDIA_ERR_DECODE",
  "4": "MEDIA_ERR_SRC_NOT_SUPPORTED",
  "5": "MEDIA_ERR_DECODE",
  "6": "MEDIA_ERR_ENCRYPTED",
  unknown: "MEDIA_ERR_UNKNOWN",
};

export interface PlayerErrorMessage {
  type: PlayerError;
}

export interface UserPlayerErrorMessage {
  type: PlayerError;
  message: string;
  messageKey?: string;
}

export type ShakaErrorEvent = CustomEvent<{
  message: string;
  messageKey?: string;
  code: number;
  category: number;
}>;

export const getErrorMessage = (message: PlayerErrorMessage) =>
  ERROR_MESSAGE_MAP[message.type];

export const getErrorMessageByStatusCode = (
  statusCode: string,
): PlayerError => {
  return (PLAYER_STATUS_CODE_TO_ERROR_MESSAGE_MAP[statusCode] ||
    PLAYER_STATUS_CODE_TO_ERROR_MESSAGE_MAP["unknown"]) as PlayerError;
};

export const getErrorMessageByCategoryCode = (
  categoryCode: string,
): PlayerError => {
  return (PLAYER_CATEGORY_CODE_TO_ERROR_MESSAGE_MAP[categoryCode] ||
    PLAYER_CATEGORY_CODE_TO_ERROR_MESSAGE_MAP["unknown"]) as PlayerError;
};
